module.exports = __webpack_public_path__ + "img/comment-sms-solid.934c45b2.svg";